module.exports = __webpack_public_path__ + "static/media/multilingue.5d011929.png";